import styled from 'styled-components';
// import UserIcon1 from '../assets/images/community/user-icon-1.webp';
// import UserIcon2 from '../assets/images/community/user-icon-2.webp';
// import UserIcon3 from '../assets/images/community/user-icon-3.webp';
import Star from '../assets/svg/Star';
import ReviewSliderBtn from './ReviewSliderBtn';
import ReviewCard from './ReviewCard';
import { useState } from 'react';
import { useRef, useEffect, useMemo } from 'react';
import { PUBLIC_IMAGES_REPO } from '../../../utils/Constants';

const UserIcon1 = `https://images.boostfloral.com/publicImagesRepo/user-icon-1.webp`;
const UserIcon2 = `https://images.boostfloral.com/publicImagesRepo/user-icon-2.webp`;
const UserIcon3 = `https://images.boostfloral.com/publicImagesRepo/user-icon-3.webp`;

const Wrapper = styled.section`
  background: var(--secoundary-secoundary-400, #d443a0);

  .container {
    max-width: 1440px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    padding: 0 6.25rem;
  }

  .testimonial-btn {
    position: absolute;
    display: flex;
    transform: rotate(8.522deg);
    padding: 6px 12px;
    color: var(--secoundary-secoundary-500-f, #cb1d8d);
    border: none;
    font-family: Instrument Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    top: 30%;
    left: 7%;
  }

  .testimonial {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1.5rem;
    padding: 6.25rem 0;

    h2 {
      color: var(--font-color-font-4, #fff);
      font-family: Instrument Sans;
      font-size: 64px;
      font-style: normal;
      font-weight: 700;
      line-height: 88px;
    }

    p {
      color: var(--font-color-font-4, #fff);
      font-family: Instrument Sans;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: 28px;
      margin: 0px;
    }
  }

  .rating {
    font-size: 20px !important;
    line-height: 28px !important;
  }

  .reviews {
    font-size: 14px !important;
    line-height: 22px !important;
  }

  .summary {
    display: flex;
  }

  .slider {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
    height: 800px;

    .line {
      background: white;
      height: 100%;
      width: 2px;
      position: absolute;
    }

    .sliderBtn {
      background-color: #d443a0;
      cursor: pointer;
      z-index: 1;
    }
  }

  .card-container {
    width: 50%;
    display: flex;
    max-height: 1200px;
    justify-content: center;
    flex-direction: column;
    overflow: hidden;
    gap: 1.5rem;
  }

  .mobile-card-placeholder {
    display: none;
  }

  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .container {
      gap: 1.5rem;
      padding: 0 3.25rem;
    }

    .testimonial-btn {
      padding: 6px 12px;
      top: 30%;
      left: 7%;
    }

    .testimonial {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 1.5rem;
      padding: 3.25rem 0;

      h2 {
        font-size: 45px;
        line-height: 58px;
      }

      p {
        font-size: 18px;
        line-height: 28px;
      }
    }

    .rating {
      font-size: 18px !important;
      line-height: 28px !important;
    }

    .reviews {
      font-size: 14px !important;
      line-height: 22px !important;
    }

    .summary {
      display: flex;
    }

    .slider {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      position: relative;
      height: 700px;
    }

    .card-container {
      width: 50%;
      max-height: 1020px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      gap: 1.5rem;
      overflow: hidden;
    }
  }

  @media screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      gap: 1rem;
      padding: 4rem 2.5rem 2rem 2.5rem;
      overflow: hidden;
    }

    .testimonial-btn {
      padding: 4px 8px;
      font-size: 12px;
      line-height: 20px;
      top: 3%;
      left: 4%;
    }

    .testimonial {
      align-items: center;
      padding: 0;
      width: 100%;

      h2 {
        font-size: 32px;
        line-height: 40px;
        width: 80%;
        text-align: center;
      }

      p {
        font-size: 16px;
        line-height: 24px;
        margin: 0px;
        text-align: center;
      }
    }

    .rating {
      display: none;
    }

    .reviews {
      display: none;
    }

    .summary {
      display: none;
    }

    .slider {
      margin: 0;
      flex-direction: row;
      height: auto;
      width: 100%;

      .line {
        height: 2px;
        width: 100%;
      }

      .sliderBtn {
        background-color: #d443a0;
        cursor: pointer;
        z-index: 1;
      }
    }

    .card-container {
      width: 100%;
      display: flex;
      flex-direction: row;
      gap: 1rem;
      overflow: initial;
      justify-content: flex-start;
      transform: translateX(${({ translateValue }) => `-${translateValue}px`});
      transition: transform 0.5s ease;
    }
  }
`;

const list = [
  {
    author: 'Steve',
    shop: 'House of Flowers',
    content:
      "BoostFloral has simplified the process of creating and managing my website, allowing me to focus more on what I love - creating beautiful floral arrangements. The platform's drag-and-drop editor is incredibly user-friendly, and I was able to build a professional-looking site in no time.",
    icon: UserIcon1,
  },
  {
    author: 'Angie',
    shop: 'Plantscapes Florist & Flower Delivery',
    content:
      "After trying other web building platforms, I finally found BoostFloral, and I couldn't be happier. The pre-designed layouts are modern and elegant, perfectly complementing my floral designs. What sets BoostFloral apart is its focus on the needs of florists and has everything I need to showcase and sell my arrangements online.",
    icon: UserIcon2,
  },
  {
    author: 'Lori',
    shop: 'Blue Ridge Florist & Gifts',
    content:
      'BoostFloral is exactly what I was looking for. Not only does it offer stunning design templates tailored for florists, but its intuitive interface makes it easy for me to update my own website without having to pay for web designers. I highly recommend BoostFloral to any florist looking to enhance their online presence.',
    icon: UserIcon3,
  },
];

const Community = () => {
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const refs = useMemo(() => [ref1, ref2, ref3], [ref1, ref2, ref3]);
  const [activeIndex, setActiveIndex] = useState(
    Math.round((list.length - 1) / 2),
  );
  const [translateValue, setTranslateValue] = useState(1);

  useEffect(() => {
    const width = refs[activeIndex]?.current?.clientWidth;
    const payload = (width + 16) * activeIndex;
    setTranslateValue(payload);
  }, [refs, activeIndex]);

  return (
    <Wrapper translateValue={translateValue}>
      <div className="container">
        <div className="testimonial">
          <h2>See what Florists like you are saying about BoostFloral</h2>
          <p>
            Beautiful floral websites that are easy to customize and simple to
            update. No hidden fees, No longterm contract, and Exceptional
            Customer Support.
          </p>
          <div className="summary align-items-center gap-1">
            <div className="d-flex">
              <Star />
              <Star />
              <Star />
              <Star />
              <Star />
            </div>
            <p className="rating">4.9 / 5</p>
            <p className="reviews">(4500+ Reviews)</p>
          </div>
        </div>
        <div className="slider">
          <div className="line" />
          {list.map((item, index) => (
            <div key={index} className="sliderBtn">
              <ReviewSliderBtn
                onClick={() => setActiveIndex(index)}
                active={activeIndex === index}
              />
            </div>
          ))}
        </div>
        <div className="card-container">
          {list?.map((item, index) => (
            <ReviewCard
              key={index}
              ref={refs[index]}
              active={activeIndex === index}
              {...item}
            />
          ))}
        </div>
        <button className="testimonial-btn">Testimonial</button>
      </div>
    </Wrapper>
  );
};
export default Community;
